import jiashaoCableTest from "./index.vue";
import jiashaoCableTestHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/jiashaoCableTestIndex",
    name: "jiashaoCableTestIndex",
    component: jiashaoCableTestHome
  },
  {
    path: "/jiashaoCableTest/login",
    name: "jiashaoLogin",
    component: login
  },
  {
    path: "/jiashaoCableTest",
    name: "jiashaoCableTest",
    redirect: "/jiashaoCableTest",
    component: jiashaoCableTest,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
